__turbopack_context__.v({
  "container": "yeA8TG_container",
});
